export default "https://cdn-static.gokick.com/assets/e031f09406d9a12f4f19fb28fc50e3428375be91/images/spearmint-flavor.30903ab4672f84579e06d9b02d9a9cc8.png";